import { ChangeDetectionStrategy, Component, computed, effect, HostListener, signal } from '@angular/core';
import { LucideAngularModule, LogIn, Menu, X } from 'lucide-angular';

// Services
import { CmsMenuService } from '@core/services/cms/cms-menu.service';
import { SessionService } from '@core/services/session.service';
import { ImageService } from '@core/services/image.service';
import { ContextService } from '@core/services/context.service';

// Models
import { CmsMenuItem } from '@core/models/cms/cms-menu.model';

/**
 * Barre de navigation publique — liens dynamiques via CmsMenuService,
 * hamburger mobile, bouton de connexion.
 */
@Component({
	selector: 'cms-navbar-layout',
	imports: [LucideAngularModule],
	templateUrl: './navbar.html',
	styleUrls: ['./navbar.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmsHeaderNavbar {
	readonly LogIn = LogIn;
	readonly Menu = Menu;
	readonly X = X;

	menuOpen = signal(false);
	readonly menuItems = computed<CmsMenuItem[]>(() => this.cmsMenuService.data() ?? []);
	readonly displayEvent = computed(() => this.sessionService.get<string>('displayevent') ?? '');
	readonly brandLine1 = computed(() => {
		const name = this.displayEvent().toUpperCase();
		const idx = name.indexOf('SKI CLUB');
		return idx !== -1 ? name.substring(idx, idx + 8) : name;
	});
	readonly brandLine2 = computed(() => {
		const name = this.displayEvent().toUpperCase();
		const idx = name.indexOf('SKI CLUB');
		return idx !== -1 ? name.substring(idx + 8).trim() : '';
	});
	readonly logoUrl: string;

	constructor(
		private cmsMenuService: CmsMenuService,
		private sessionService: SessionService,
		private imageService: ImageService,
		private contextService: ContextService,
	) {
		this.logoUrl = this.imageService.getAppIcon();
		effect(() => {
			const nomdt = this.sessionService.get<number>('nomdt');
			if (nomdt) {
				this.cmsMenuService.load(nomdt);
			}
		});
	}

	toggleMenu(): void {
		this.menuOpen.update((v) => !v);
	}

	closeMenu(): void {
		this.menuOpen.set(false);
	}

	login(): void {
		window.location.href = `/${this.contextService.getCurrent()}/login`;
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.mobile-menu, .hamburger')) {
			this.menuOpen.set(false);
		}
	}
}
